
export default function VictoriaMarket() {
  const marketStats = [
    {
      icon: 'ri-money-dollar-circle-line',
      value: '$180-$280',
      label: 'Average Nightly Rate',
      description: 'Premium rates in BC\'s capital city'
    },
    {
      icon: 'ri-percent-line',
      value: '70%',
      label: 'Average Occupancy',
      description: 'Strong year-round tourism demand'
    },
    {
      icon: 'ri-calendar-check-line',
      value: '365',
      label: 'Max Rental Days',
      description: 'No night cap for principal residence'
    },
    {
      icon: 'ri-line-chart-line',
      value: '$45K-$72K',
      label: 'Annual Revenue Potential',
      description: 'For compliant 1-2 bedroom properties'
    }
  ];

  const neighborhoods = [
    {
      name: 'James Bay',
      demand: 'Very High',
      avgRate: '$220-$280',
      notes: 'High demand, near Inner Harbour and Parliament'
    },
    {
      name: 'Downtown & Inner Harbour',
      demand: 'Very High',
      avgRate: '$200-$260',
      notes: 'Tourist hotspot, cruise ship visitors'
    },
    {
      name: 'Fairfield',
      demand: 'High',
      avgRate: '$180-$240',
      notes: 'Beach access, residential charm'
    },
    {
      name: 'Fernwood',
      demand: 'Medium-High',
      avgRate: '$160-$220',
      notes: 'Local vibe, arts community'
    }
  ];

  const seasonalTrends = [
    {
      season: 'Summer (Jun-Sep)',
      demand: 'Peak',
      rate: '+30% above average',
      description: 'Tourism peak, cruise season, festivals, 2026 World Cup spike'
    },
    {
      season: 'Spring (Mar-May)',
      demand: 'High',
      rate: '+20% above average',
      description: 'Gardens bloom, spring break travel'
    },
    {
      season: 'Fall (Sep-Nov)',
      demand: 'Medium-High',
      rate: '+10% above average',
      description: 'Mild weather, fall colors'
    },
    {
      season: 'Winter (Dec-Feb)',
      demand: 'Medium',
      rate: 'Average rates',
      description: 'Mild climate, holiday visitors'
    }
  ];

  return (
    <section className="py-24 lg:py-32 bg-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="text-center mb-16 max-w-3xl mx-auto">
          <span className="inline-block bg-[#882629]/10 text-[#882629] px-4 py-2 rounded-full text-sm font-medium mb-4">
            Market Analysis
          </span>
          <h2 className="font-['Fraunces'] text-4xl lg:text-5xl font-bold text-[#505A5A] mb-6">
            Victoria 2026 STR Market Demand
          </h2>
          <p className="text-lg text-[#505A5A]/70 leading-relaxed">
            Victoria's tourism-driven economy creates strong STR demand year-round. High demand in James Bay near Inner Harbour, with 2026 World Cup creating summer peak opportunities.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6 mb-16">
          {marketStats.map((stat, index) => (
            <div
              key={index}
              className="bg-[#F8F8F8] rounded-xl p-6 text-center hover:shadow-lg transition-all"
            >
              <div className="w-14 h-14 bg-[#882629]/10 rounded-full flex items-center justify-center mx-auto mb-4">
                <i className={`${stat.icon} text-2xl text-[#882629]`}></i>
              </div>
              <div className="text-3xl font-bold text-[#882629] mb-2">{stat.value}</div>
              <div className="text-base font-semibold text-[#505A5A] mb-2">{stat.label}</div>
              <p className="text-sm text-[#505A5A]/70">{stat.description}</p>
            </div>
          ))}
        </div>

        <div className="grid lg:grid-cols-2 gap-12 mb-16">
          <div>
            <h3 className="text-2xl font-semibold text-[#505A5A] mb-6">
              High-Demand Neighborhoods
            </h3>
            <div className="space-y-4">
              {neighborhoods.map((area, index) => (
                <div
                  key={index}
                  className="bg-[#F8F8F8] rounded-xl p-6 hover:shadow-md transition-all"
                >
                  <div className="flex items-center justify-between mb-2">
                    <h4 className="text-lg font-semibold text-[#505A5A]">{area.name}</h4>
                    <span
                      className={`text-xs font-semibold px-3 py-1 rounded-full whitespace-nowrap ${
                        area.demand === 'Very High'
                          ? 'bg-green-100 text-green-800'
                          : area.demand === 'High'
                          ? 'bg-blue-100 text-blue-800'
                          : 'bg-yellow-100 text-yellow-800'
                      }`}
                    >
                      {area.demand}
                    </span>
                  </div>
                  <p className="text-sm text-[#505A5A]/70 mb-2">{area.notes}</p>
                  <div className="text-base font-semibold text-[#882629]">{area.avgRate}</div>
                </div>
              ))}
            </div>
          </div>

          <div>
            <h3 className="text-2xl font-semibold text-[#505A5A] mb-6">
              2026 Seasonal Demand
            </h3>
            <div className="space-y-4">
              {seasonalTrends.map((trend, index) => (
                <div
                  key={index}
                  className="bg-[#F8F8F8] rounded-xl p-6 hover:shadow-md transition-all"
                >
                  <div className="flex items-center justify-between mb-2">
                    <h4 className="text-lg font-semibold text-[#505A5A]">{trend.season}</h4>
                    <span
                      className={`text-xs font-semibold px-3 py-1 rounded-full whitespace-nowrap ${
                        trend.demand === 'Peak'
                          ? 'bg-green-100 text-green-800'
                          : trend.demand === 'High'
                          ? 'bg-blue-100 text-blue-800'
                          : 'bg-yellow-100 text-yellow-800'
                      }`}
                    >
                      {trend.demand}
                    </span>
                  </div>
                  <div className="text-base font-semibold text-[#882629] mb-2">{trend.rate}</div>
                  <p className="text-sm text-[#505A5A]/70">{trend.description}</p>
                </div>
              ))}
            </div>
          </div>
        </div>

        <div className="bg-[#882629]/5 border-l-4 border-[#882629] rounded-lg p-8">
          <div className="flex items-start gap-4">
            <i className="ri-information-line text-3xl text-[#882629] flex-shrink-0"></i>
            <div>
              <h4 className="text-xl font-semibold text-[#505A5A] mb-3">
                Maximize Victoria STR Revenue
              </h4>
              <p className="text-base text-[#505A5A]/70 leading-relaxed">
                James Bay sees high demand year-round due to proximity to Inner Harbour and Parliament Buildings. The 2026 World Cup creates a summer spike with rates 30% above average. Our professional management helps compliant operators achieve optimal revenue while maintaining Provincial Registry compliance.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
